import { Post } from "../utils/http.js"

function getCommonfromLoc() {
  const { commonReqParams } = JSON.parse(localStorage.getItem("commData"))
  return {
    vendorId: commonReqParams.venderId,
    venderId: commonReqParams.venderId
  }
}

export function getCollectProcess(params) {
  const commonParams = getCommonfromLoc()
  return Post(
    "/api/coudan/v20/process",
    {
      param: JSON.stringify({
        ...commonParams,
        ...params
      })
    },
    {
      showTips: true
    }
  )
}

export function getCollectList(params) {
  const commonParams = getCommonfromLoc()
  return Post(
    "/api/coudan/v20/coudan",
    {
      param: JSON.stringify({
        businessType: "1",
        type: "promotion",
        limit: 20,
        offset: 0,
        ...commonParams,
        ...params
      })
    },
    {
      showTips: true
    }
  )
}
